import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

export const useGetTimeAgo = () => {
  const { t } = useTranslation();

  const getTimeAgo = ({ dateString }: { dateString: string }): string => {
    const date = dayjs(dateString);
    const now = dayjs();

    const diffHours = now.diff(date, 'hour');
    const diffDays = now.diff(date, 'day');

    if (diffHours < 1) return t('Last hour');
    if (diffHours < 24) return t('Hours ago', { diffHours: diffHours });
    if (diffDays === 1) return t('Yesterday');

    return t('Days ago', { diffDays: diffDays });
  };

  return { getTimeAgo };
};
